import cn from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './Tooltip.module.scss';

interface ITooltipProps {
  overlayClassName?: string;
  placement?: string;
  content: ReactNode;
}

const Tooltip: FC<ITooltipProps> = ({ overlayClassName, placement = 'right', content, children }) => {
  const overlayClassNames = cn(
    styles.TooltipContainer,
    overlayClassName,
    styles[`TooltipPlacement${placement.charAt(0).toUpperCase()}${placement.slice(1)}`],
  );
  return (
    <div className={styles.Tooltip}>
      <span className={styles.TooltipIcon}>{children}</span>
      <div className={overlayClassNames}>{content}</div>
    </div>
  );
};

export { Tooltip };
